<template>
  <!-- 标签数长度小于0时不展示楼层 -->
    <div class="box" v-if="jobTabComponentDTO.jobTabList.length > 0">
        <TabItem
        :componentConfig="componentConfig"
        :tabs="jobTabComponentDTO.jobTabList"
        :pageConfig="pageConfig"
        :activeColor="backgroundConfigDTO.selectedTabTextColor"
        :deActiveColor="backgroundConfigDTO.unSelectedTabTextColor"
        :activeBg="backgroundConfigDTO.selectedTabIconUrl"
        :deActiveBg="backgroundConfigDTO.unSelectedTabIconUrl"
        @changeTab="changeTab"
        ></TabItem>
        <div
        class="urgentRecruitmentCompany_wrap"
        :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
        >
        <div class="header" :style="{'--alignItems': pageConfig.customBackground != 1 ? 'baseline' : 'flex-start' }" :class="[componentType == 2 ? 'goodheader' : '']">
            <div class="header_info" v-if="componentType != 2">
            <span
                class="header_title"
                :style="{
                textShadow: `0px 2px 8px ${buttonColor}`,
                }"
                >
                {{ limitText(curItem.title || componentConfig.title) }}
                </span
            >
            <span
                class="header_desc"
                :style="{ textShadow: `0px 2px 8px ${buttonColor}` }"
                >
                {{ subTitle }}
                </span
            >
            </div>
            <template v-if="jumpButtonConfig.type == '2' && jumpButtonConfig.activityId">
            <div
                class="header_jump"
                @click="handlePageJump"
                :style="{ background: buttonColor }"
            >
                <span class="text">查看更多</span>
                <span class="icon"></span>
            </div>
            </template>
            <template v-else-if="componentType != 2">
            <div
                class="header_change"
                @click="handleChangeJob"
                :style="{ background: buttonColor }"
            >
                <span class="icon"></span>
                <span class="text">换一换</span>
            </div>
            </template>
        </div>
        <div class="content" v-if="urgentJobList?.length == 0 && loading">
            <div v-for="(e, eI) in 4" :key="eI" class="empty">
            <div class="skeleton"></div>
            </div>
        </div>
        <Empty v-else-if="urgentJobList?.length == 0 && !loading" />
        <div v-else>
            <div class="content">
            <div
                class="job_con sensors_exposure"
                v-for="(item, index) in urgentJobList"
                :key="index"
                @click="clickJobCard(item, index)"
                sensorsname="JobShortExposure"
                :sensorsdata="buildJobShortExposureParams(item, index)"
            >
                <div class="com_name">
                <div class="companyBox">
                    <span class="companyname" @click.stop="clickCompany(item, index)">{{
                    item.companyName
                    }}</span>
                    <span class="icon"></span>
                </div>
                <!-- 城市 -->
                <span class="cityName" v-if="item.jobAreaString">{{cityStr(item.jobAreaString)}}</span>
                </div>
                <div class="job_info">
                <div class="nameandsalary">
                    <span class="jobname">{{ item.jobName }}</span>
                    <span class="jobsalary">{{ item.provideSalaryString }}</span>
                </div>
                <div
                    class="chatBtn"
                    @click.stop="gotoChat(item)"
                    v-if="buttonTypeChat(item)"
                >
                    去聊聊
                </div>
                <div
                    :class="{ deliverBtn: true, delivered: item.isApply }"
                    @click.stop="gotoDeliver(item, index)"
                    v-else
                >
                    <span v-if="!item.isApply" class="icon"></span>
                    <span>{{ item.isApply ? "已投递" : "投递" }}</span>
                </div>
                <!-- </template> -->
                </div>
                <!-- 福利词 -->
                <div class="welfare_wrap" v-if="item.customWelfareList">
                <img src="@/assets/img/activity/tag_quick.png" alt="" />
                <div class="welfare_text">{{ welfare(item.jobTags) }}</div>
                </div>
                <div class="hr" v-else>
                <div class="hr_info">
                    <div class="hravatar">
                    <img v-if="item.smallHrLogoUrl" :src="item.smallHrLogoUrl" />
                    <img
                        v-else
                        :src="
                        require(`@/assets/img/activity/${
                            item.isFromXyx ? 'message_hr_fromxy' : 'message_hr_def'
                        }.png`)
                        "
                    />
                    <div v-if="item.isOnline" class="circle"></div>
                    </div>
                    <div class="hrname">
                    {{ item.isFromXyx ? "应届生网申职位" : item.hrName || "HR" }}
                    </div>
                </div>
                <div class="hrtag">{{ item.hrLabels ? item.hrLabels[0] : "" }}</div>
                </div>
            </div>
            </div>
            <!--一键投递-->
            <div
            v-if=" this.componentConfig.postButtonType == 1"
            :class="{
                deliverysBtn: true,
                deliverysBtnGray: delivarysJobList.length == 0,
            }"
            @click="handleDeliverys"
            >
            一键投递
            <div class="mengcen"></div>
            </div>
            <!--点击加载更多职位-->
            <!-- <div 
            v-else
            :class="{
                moreBtn: true,
                moreBtnHide: urgentJobList.length == 0 || pageNum > totalPages
            }"
            >
            <van-loading v-if="loading" />
            <span class="text" @click="addMore" v-if="!loading">点击查看更多</span>
            </div> -->
        </div>
        </div>
    </div>
  </template>
  <script>
  import { mapState, mapActions } from "vuex";
  import Empty from "../common/EmptyData.vue";
  import TabItem from './components/TabItem.vue'
  export default {
    name: "DoubleColumnLabel",
    components: { Empty,TabItem},
    props: {
      pageConfig: {
        type: Object,
        default: () => {},
      },
      componentConfig: {
        type: Object,
        default: () => {},
      },
      goodJobZone: { // 好职专区用参数
        type: Object,
        default: () => {},
      },
      goodRank: {
        default: () => { return '' }
      },
      componentType: { // 1:默认组件-右上刷新/链接 2:专区组件-更多加载职位
        type: Number,
        default: () => { return 1}
      }
    },
    data() {
      return {
        urgentJobList: [],
        jobOrCompanyIdList: [], //下次请求列表带上次返回数组
        // 一键投递列表 排除网申和已投递
        delivarysJobList: [],
        pageNum: 1,
        pageSize: 4,
        totalPages: 0, //数据总页数
        loading: true,
        requestId: "",
        curItem:{}
      };
    },
    computed: {
      ...mapState(["commonStore","resumeStore"]),
      platform() {
        return this.commonStore.platform;
      },
      jumpButtonConfig() {
        return this.curItem?.jumpButtonConfigDTO || this.componentConfig?.jumpButtonConfigDTO || {};
      },
      backgroundImage() { //背景图,自定义取组件内的(取不到组件内的取活动页的作为兜底),非自定义取活动页的
        let moduleIconUrl = ''
        if(this.pageConfig.customBackground == 1){//自定义组件
          moduleIconUrl = !this.commonStore.isForPC ? this.curItem.moduleIconUrl || this.pageConfig.moduleIconUrl : this.curItem.moduleIconPcUrl || this.pageConfig.moduleIconPcUrl;
        }else{
          moduleIconUrl = !this.commonStore.isForPC ? this.pageConfig.moduleIconUrl : this.pageConfig.moduleIconPcUrl
        }
        return moduleIconUrl;
      },
      jobTabComponentDTO(){//标签页
        return this.componentConfig?.jobTabComponentDTO || {};
      },
      backgroundConfigDTO(){//组件样式
        return this.componentConfig?.backgroundConfigDTO || {};
      },
      //楼层标题最大字数7个字
      limitText() {
        return function(text, maxLength = 7) {
          if(text){
            return text.length > maxLength ? `${text.slice(0, maxLength)}` : text;
          }else{
            return ''
          }
        };
      },
      subTitle(){//组件副标题,自定义组件不显示副标题
        let result = ''
        result = this.pageConfig.customBackground != 1 ? this.curItem.subTitle || this.componentConfig.subtitle : '';
        return result
      },
      buttonColor(){
        return this.backgroundConfigDTO.buttonColor || this.pageConfig.buttonColor
      },
      cityStr(){//截取城市字段
       return function(jobAreaString){
          jobAreaString = jobAreaString.split("·")[0];
          return jobAreaString;
        }
      },
    },
    watch: {
      "commonStore.currentAreaCode": {
        handler() {
          console.log("触发了吗")
          this.pageNum = 1;
          this.loading = true;
          this.jobOrCompanyIdList = [];
          this.urgentJobList = [];
          this.queryJobList();
        },
        immediate: false,
      }
    },
    mounted() {   
      if (this.componentType === 2) { // 好职专区好职专区的逻辑暂时留着,双列+标签不走此逻辑
        this.queryGoodJobList();
      } else {//双列+标签组件
        this.curItem = this.jobTabComponentDTO.jobTabList[0]
        console.log('this.curItem',this.curItem);
        this.queryJobList();
      }
    },
    methods: {
      //顶部tab切换
      changeTab(item){
        this.pageNum = 1;
        this.loading = true;
        this.urgentJobList = [];
        this.jobOrCompanyIdList = [];
        this.curItem = item
        this.queryJobList();
      },
      welfare(jobTags) {
        return jobTags.join(",");
      },
      buttonTypeChat(item) {
        let platform = this.platform;
        let isApp = this.$store.getters.isApp;
        // TODO 测试删除
        // platform = "yjsApp"
        // isApp = true
        //
        if (isApp) {
          if (platform == "51jobApp") {
            // 51
            return item.buttonType == 1;
          } else if (platform == "yjsApp") {
            // yjs
            return item.isApply;
          }
        }
        return false;
      },
      ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
      buildJobShortExposureParams(item, index) {
  
        if (this.componentType == 2) {
          const property = JSON.parse(item.property);
          const val = `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`;
  
          property.pageCode = val;
          property.shortPageCode = val;
  
          item.property = JSON.stringify(property);
        }
  
        if (this.goodRank !== '') {
          return this.$base.getJobShortExposureParams(
            item,
            index,
            this.urgentJobList.length,
            {
              subContentRank: this.goodRank
            }
          );
        } else {
          return this.$base.getJobShortExposureParams(
            item,
            index,
            this.urgentJobList.length,
          );
        }
      },
      // 职位列表
      async queryJobList(type='default') {
        if (this.finished) return;
        const params = {
          strategyId:this.curItem?.strategyId,
          componentId: this.componentConfig?.id,
          cityCode: this.commonStore.currentAreaCode,
          funcCode: this.$route.query?.funcCode
            ? this.$route.query?.funcCode
            : this.commonStore.intention?.expectFunction || "",
          pageNum: this.pageNum,
          pageSize: this.componentConfig?.jobNumber
            ? this.componentConfig?.jobNumber
            : this.pageSize,
          requestId: this.requestId,
          jobOrCompanyIdList: this.jobOrCompanyIdList,
          workFuncStr: this.commonStore.intention?.expectFunctionString,
          expectWorkArea: this.commonStore.intention?.expectArea,
          expectIndustry: this.commonStore.intention?.expectIndustry,
          expectIndustryNew: this.commonStore.intention?.expectIndustry,
          expectMinSalary: this.commonStore.intention?.minSalary,
          expectMaxSalary: this.commonStore.intention?.maxSalary,
          busBelong: this.pageConfig.busBelong || "51job",
          seekType: this.commonStore.intention?.seekType || "",
          userIdentity:
            this.commonStore.identityType == "职场人"
              ? 0
              : this.commonStore.identityType == "在校生"
              ? 1
              : 0,
          degree:this.resumeStore.resume?.c.education[0]?.degree || '',
          major:this.resumeStore.resume?.c.education[0]?.major || '',  
          resideCity:this.resumeStore.resume?.accountInfo?.area || '',
        };
        const property = {
          pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
        };
        const res = await this.$api.activity.getActivityJobList(params, {
          property,
        });
        
        if (type == 'readonly') { // 仅用于获取下一页数但不更新页码
          let result = []
          if (res?.code == "0") {
            result = res.data.jobInfoList.result
          }
          return result
        }
        
        if (res?.code == "0") {
          this.loading = false;
          const { jobOrCompanyIdList, jobInfoList, requestId } = res.data;
          this.jobOrCompanyIdList = jobOrCompanyIdList;
          this.requestId = requestId;
          if (jobInfoList.result.length > 0) {
            this.totalPages = jobInfoList.totalPages
            this.pageNum = this.pageNum < jobInfoList.totalPages ? this.pageNum + 1 : 1
            this.urgentJobList = jobInfoList.result;
            this.delivarysJobList = this.urgentJobList.filter(
              (item) => !item.isFromXyx && !item.isApply
            );
          }
  
          this.$nextTick(() => {
            this.$exposure.sensorsExposure();
          });
        } else {
          this.urgentJobList = [];
          this.loading = false;
        }
      },
      async queryGoodJobList() { // 获取专区数据列表
        let personAsLabel = this.$store.getters.personAsLabelModify;
        if (!personAsLabel) {
          if (location.href.indexOf('51job')) {
            personAsLabel = 1;
          } else {
            personAsLabel = 2;
          }
        }
  
        const params = {
          function: this.$route.query?.funcCode
            ? this.$route.query?.funcCode
            : this.commonStore.intention?.expectFunction || "",
          jobArea: this.commonStore.currentAreaCode,
          salary: "2000-1000000",
          pageNum: this.pageNum,
          pageSize: this.componentConfig?.jobNumber
            ? this.componentConfig?.jobNumber
            : this.pageSize,
          requestId: this.requestId,
          scene: 2,
          searchType: 2,
          personAsLabel: personAsLabel,
          specialPageId: this.goodJobZone.id,
          jobTags: this.goodJobZone.jobTags,
          pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`
        };
        const res = await this.$api.activity.getSearchJobList(params)
        this.loading = false;
  
        if (res?.status == "1") {
          const { job, requestId } = res.resultbody;
          this.totalPages = Math.ceil(job.totalCount / this.pageSize);
          this.pageNum++;
          this.requestId = requestId;
          this.urgentJobList = [ ...this.urgentJobList, ...job.items];
  
          this.$nextTick(() => {
            this.$exposure.sensorsExposure();
  
            this.$emit('updateComLocation')
          });
        }
      },
      handleChangeJob() {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_joblist2_more",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: this.componentConfig.title,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          },
          contentType: '刷新职位'
        });
        this.loading = true;
        this.delivarysJobList = [];
        this.urgentJobList = [];
        this.queryJobList();
      },
      handlePageJump() {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_joblist2_more",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: this.componentConfig.title,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          },
          contentType: '跳转活动页'
        });
  
        let jumpUrl = '';
        let deeplinkid = this.$route.query.deeplinkid || localStorage.getItem("deeplinkid");
  
        if (this.platform.includes("App")) {
          jumpUrl = this.jumpButtonConfig.jumpLinkDTO.jumpLinkApp;
        } else if (this.commonStore.appType == 'weixin' && this.platform.indexOf('WX') == -1) {
          jumpUrl = this.jumpButtonConfig.jumpLinkDTO.jumpLinkWx;
  
          let _jumpurl = this.getUrlBeforeQuestionMark(jumpUrl);
          let params = this.getUrlParams(jumpUrl);
          let query = "";
          if (_jumpurl == "pages/op/index") {
            query =
              `id=${params.id}` +
              (deeplinkid ? `&deeplinkid=${deeplinkid}` : "");
          } else {
            query = deeplinkid ? `&deeplinkid=${deeplinkid}` : "";
          }
          this.handleMiniLogin(_jumpurl, query);
  
          return;
        }
        jumpUrl = jumpUrl ? jumpUrl : this.jumpButtonConfig.jumpLinkDTO.jumpLinkH5;
  
        location.href = jumpUrl;
      },
      // 获取url问号之前的部分
      getUrlBeforeQuestionMark(url) {
        var index = url.indexOf("?");
        if (index !== -1) {
          return url.substring(0, index);
        } else {
          return url;
        }
      },
      getUrlParams(curl) {
        let url = curl;
        let params = {};
        let queryString = url.split("?")[1] || "";
        let keyValuePairs = queryString.split("&") || [];
        if (keyValuePairs.length > 0) {
          for (var i = 0; i < keyValuePairs.length; i++) {
            var keyValue = keyValuePairs[i].split("=");
            params[decodeURIComponent(keyValue[0])] = decodeURIComponent(
              keyValue[1]
            );
          }
        }
        return params;
      },
      // 小程序跳转
      handleMiniLogin(path, query) {
        const params = {
          from_domain: this.platform.includes("yjs")
            ? "yjs_wxapp"
            : "51job_weixin_wxapp",
          rand: this.generate6DigitUUID(9),
          guid: this.generate6DigitUUID(5),
          wx_biz: {
            path: path,
            query: query,
            expire_type: 1,
            expire_time: new Date().getTime() + 24 * 60 * 60 * 1000,
            expire_interval: 1,
            env_version:
              process.env.NODE_ENV === "production" ? "release" : "trial",
          },
        };
        console.log(
          this.platform,
          this.platform.includes("yjs"),
          params,
          "小程序跳转--------------"
        );
        this.$api.activity.getWxUrl(params).then((res) => {
          console.log(res);
          const { url_link = {} } = res.resultbody || {};
          if (url_link.errcode == "0") {
            const link = url_link.url_link;
            window.location.href = link;
          } else {
            this.$toast("获取微信短链失败");
          }
        });
      },
      generate6DigitUUID(num) {
        return Math.floor(100000 + Math.random() * (9 * 10 ** num)).toString();
      },
      clickJobCard(item, index) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_joblist",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName:this.curItem.title,
          contentType: "职位",
          contentId: item.jobId,
          contentRank: `${index}`,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
            subContentRank: `${this.goodRank}`,
          },
        });
  
        if (this.$base.checkLoginStatus(true)) {
          this.$base.toJobDetail(item);
        }
      },
      clickCompany(item, index) {
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_colist",
          moduleName: `${this.componentConfig.sort}|${this.componentConfig.type}`,
          contentName: this.componentConfig.title,
          contentType: "公司",
          contentId: item.coId,
          contentRank: `${index}`,
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|colist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
            subContentRank: `${this.goodRank}`,
          },
        });
  
        if (
          !["yjsM", "yjsPC"].includes(this.platform) &&
          !this.$base.checkLoginStatus(true)
        )
          return;
        this.$base.toCompanyDetail(item, index, true);
      },
      // 单投
      gotoDeliver(item, index=-1) {
        if (this.$base.checkLoginStatus(true) && !item.isApply) {
          if (item.isFromXyx) {
            //网申
            this.$base.toJobDetail(item);
          } else {
            // 单投
            const property = (item?.property && JSON.parse(item.property)) || {};
            const params = {
              item: { ...item, jobId: String(item.jobId) },
              property: {
                ...property,
                fromModule: "列表单投",
              },
              isShowToast: "0",
              onSuccess: () => {
                this.$emit("goQuestionSet", [item]);
                this.changeItemIsApply(item);
                this.$store.commit("setValueLocalStorage", {
                  applyJobRefreshTasks:
                    this.$store.state.commonStore.applyJobRefreshTasks + 1,
                });
  
                if (this.componentType != 2) {
                  this.updateJobList(index)
                }
              },
            };
            this.applyJob(params);
          }
        }
      },
      // 单投成功后，列表更新已投递职位
      async updateJobList(index) {
        // 获取下一页数据
        const data = await this.queryJobList('readonly')
        let job = data.filter((item) => {
          return !item.isApply
        })
        job = job.length ? job[0] : ''
  
        // 更新数据
        if (job) {
          if (!job.isFromXyx) {
            this.delivarysJobList.push(job)
          }
          this.urgentJobList.splice(index, 1, job)
        }
      },
      gotoChat(item) {
        if (this.$base.checkLoginStatus(true)) {
          let property = {
            pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
          };
          this.$base.goChatNew(item, this.$store.state.commonStore, property);
        }
      },
      handleDeliverys() {
        if (this.delivarysJobList.length > 0) {
          if (this.$base.checkLoginStatus(true)) {
            if (!this.$store.state.commonStore.accountId) {
              this.$toast.fail("投递失败，请先完善简历");
              return false;
            }
            // 需过滤网申和已投递职位
            this.$toast.loading({
              message: "稍等片刻",
              forbidClick: true,
              className: "waiting-apply",
            });
            let item = this.delivarysJobList[0]
            const property = (item?.property && JSON.parse(item.property)) || {};
            this.batchApplyJob({ 
              jobList: this.delivarysJobList,
              property: {
                ...property,
                // pageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
                // shortPageCode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}`,
                fromModule: "列表批投",
              },
              onResult: ({ allSuccess, arrSuccess, arrFail, resultArr }) => {
                console.log(
                  "onResult",
                  allSuccess,
                  arrSuccess,
                  arrFail,
                  resultArr
                );
  
                if (allSuccess) {
                  this.$toast.clear();
                  this.$emit("goQuestionSet", this.delivarysJobList);
                  setTimeout(() => {
                    this.urgentJobList = [];
                    this.handleChangeJob();
                  }, 1000);
                } else {
                  this.$toast.clear();
                  this.$toast.fail("部分职位需要进入详情页单独投递~");
                }
                this.$store.commit("setValueLocalStorage", {
                  applyJobRefreshTasks:
                    this.$store.state.commonStore.applyJobRefreshTasks + 1,
                });
              },
            });
            return;
          }
        }
      },
      // 投递成功后按钮展示已投递
      changeItemIsApply(item) {
        console.log(
          this.urgentJobList,
          item,
          item.jobId,
          this.urgentJobList.find((job) => job.jobId === item.jobId),
          "changeItemIsApply"
        );
        this.urgentJobList.find((job) => {
          console.log(job.jobId, item.jobId, "changeItemIsApply");
          return job.jobId === item.jobId;
        }).isApply = true;
      },
      // 加载更多职位
      addMore() {
        if (this.loading) {
          return false;
        }
  
        this.$sensors.track("$WebClick", {
          $element_id: "sensor_bcop_viewmore",
          moduleName: `${this.goodRank}|${this.componentConfig.type}`,
          contentName: this.goodJobZone.pageTitle,
          contentType: '职位',
          bcopExrinfo: {
            pagecode: `YC|${this.$route.params.pageId}|${this.componentConfig.sort}|${this.componentConfig.type}|joblist|${this.componentConfig.id}|${this.pageConfig.activityZoneId}|${this.curItem?.strategyId}`,
            subContentRank: `${this.goodRank}`,
          },
        });
  
        this.loading = true;
        this.queryGoodJobList();
      }
    },
  };
  </script>
  <style scoped lang="less">
.urgentRecruitmentCompany_wrap {
  width: 100%;
  box-sizing: border-box;
  border-radius: 12px 12px 0px 0px;
  overflow: hidden;
  padding-bottom: 24px;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  position: relative;

  .adapt_pc_widescreen & {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 40px;
  }
  .header {
    display: flex;
    align-items: var(--alignItems);
    padding: 13px 8px 4px 8px;
    justify-content: space-between;
    .adapt_pc_widescreen & {
       padding: 24px 24px 17px 24px;
    }
    &.goodheader {
      padding: 0 0 13.3%;
    }
    .header_info {
      .header_title {
        width: 98px;
        // font-family: HarmonyOS_Sans_SC_Bold;
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 8px;
        .adapt_pc_widescreen & {
          font-size: 28px;
        }
      }
      .header_desc {
        // font-family: HarmonyOS_Sans_SC_Medium;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-shadow: 0px 2px 8px #e16e69;
        margin-left: 9px;
        .adapt_pc_widescreen & {
          font-size: 18px;
        }
      }
    }
    .header_change, .header_jump {
      width: 74px;
      height: 25px;
      // background: #f96440;
      border-radius: 13px;
      color: #ffffff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      // margin-left: 19px;
      // line-height: 25px;//区别
      .adapt_pc_widescreen & {
        width: 112px;
        height: 38px;
        border-radius: 24px;
        font-size: 18px;
        position: absolute;
        top: 20px;
        right: 16px;
      }
      .icon {
        width: 16px;
        height: 16px;
        background: url("@/assets/img/activity/change@3x.png") ;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        .adapt_pc_widescreen & {
          width: 20px;
          height: 20px;
        }
      }
      .text {
        margin-left: 2px;
      }
    }
    .header_jump {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 25px; //区别
      .icon {
        display: inline-block;
        width: 10px;
        height: 10px;//区别
        background: url("@/assets/img/activity/arrow_small_line.png");
        background-size: contain;//区别
        background-repeat: no-repeat;//区别
        .adapt_pc_widescreen & {//区别
          width: 13px;
          height: 13px;
        }
      }
      .text {
        // margin:0 2px 0 0; //区别
      }
    }
  }
  .content {
    border-radius: 8px;
    margin: 6px 8px;
    padding-bottom: 4px;
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 5px;
    .adapt_pc_widescreen & {
      grid-template-columns: repeat(4, 1fr);
      margin: 0 16px 6px;
      grid-gap: 12px;
    }
    .empty {
      // width: 177px;
      height: 109px;
      border-radius: 8px;
      box-sizing: border-box;
      position: relative;
      border: 1px solid #ffffff;
      cursor: pointer;
      background-image: url("@/assets/img/activity/empty.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .skeleton {
      width: 100%;
      height: 100%;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 24%,
        rgba(255, 255, 255, 0.9) 25%,
        rgba(255, 255, 255, 0.9) 75%,
        rgba(255, 255, 255, 0) 76%,
        rgba(255, 255, 255, 0) 100%
      );
      background-size: 50% 100%;
      filter: blur(25px);
      animation: gradient 1.5s linear infinite;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }

      100% {
        background-position: 100% 50%;
      }
    }

    .job_con {
      height: 109px;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      padding: 9px 7px 6px 9px;
      .adapt_pc_widescreen & {
        height: 128px;
        padding: 12px 12px 8px 12px;
      }
      .com_name {
        width: 100%;
        height: 16px;
        font-weight: 400;
        font-size: 12px;
        color: #4c4f54;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: center;
        overflow: hidden;
        .companyBox{
          flex: 1;
          overflow: hidden;
          display: flex;
          align-items: center;
          .companyname {
            max-width: 80%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .adapt_pc_widescreen & {
              font-size: 14px;
            }
          }
          .icon {
            width: 5px;
            height: 9px;
            background: url("@/assets/img/activity/arrow_right@3x.png");
            background-size: 100% 100%;
            margin-left: 4px;
          }
        }
        .cityName{
          font-size: 11px;
          font-weight: normal;
          line-height: 14px;
          color: #AFB3BA;
          .adapt_pc_widescreen & {
            font-size: 14px;
          }
        }
      }
      .job_info {
        width: 100%;
        margin-top: 8px;
        display: flex;
        .nameandsalary {
          flex: 1;
          font-size: 14px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-right: 4px;
          .jobname {
            color: #222222;
            // font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .adapt_pc_widescreen & {
              font-size: 18px;
            }
          }
          .jobsalary {
            color: #ff6c0e;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            
            .adapt_pc_widescreen & {
              font-size: 16px;
              font-weight: 600;
            }
          }
        }
        .chatBtn,
        .deliverBtn {
          width: 64px;
          height: 30px;
          box-sizing: border-box;
          background: linear-gradient(180deg, #ffbd65 0%, #ff6332 100%);
          border-radius: 15px;
          color: #ffffff;
          font-size: 12px;
          text-align: center;
          margin-top: 5px;
          font-weight: 600;
          // border: 1px solid #ffd3bf;
          display: flex;
          align-items: center;
          justify-content: center;
          letter-spacing: 1px;
          .adapt_pc_widescreen & {
            width: 69px;
            height: 33px;
            border-radius: 20px;
            font-size: 14px;
          }
          .icon {
            width: 16px;
            height: 16px;
            background: url("@/assets/img/activity/send-white@2x.png");
            background-size: cover;
            margin-right: 2px;
          }
        }
        .delivered {
          background: #b8b8b8;
          border: 0;
        }
      }
      .welfare_wrap {
        border-radius: 4px;
        background: #fff8ed;
        display: inline-flex;
        align-items: center;
        height: 20px;
        padding: 0 4px;
        margin-top: 8px;
        max-width: 161px;
        .adapt_pc_widescreen & {
          max-width: 259px;
          height: 24px;
        }
        img {
          width: 10px;
          height: 8px;
          .adapt_pc_widescreen & {
            width: 12px;
            height: 10px;
          }
        }
        .welfare_text {
          margin-left: 4px;
          font-size: 10px;
          font-weight: normal;
          line-height: 16px;
          letter-spacing: 0px;
          color: #ff6c0e;
          // max-width: 100px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          .adapt_pc_widescreen & {
            font-size: 12px;
          }
        }
      }
      .hr {
        width: 100%;
        margin-top: 8px;
        display: flex;
        align-content: center;
        justify-content: space-between;
        line-height: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        .adapt_pc_widescreen & {
          font-size: 13px;
        }
        .hr_info {
          display: flex;
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          align-items: center;
          .hravatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            min-width: 20px;
            background: #ffffff;
            position: relative;
            .adapt_pc_widescreen & {
              width: 24px;
              height: 24px;
            }
            & > img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
            .circle {
              display: inline-block;
              width: 8px;
              height: 8px;
              background: #2dd685;
              border-radius: 4px;
              border: 2px solid #ffffff;
              position: absolute;
              right: -3px;
              bottom: 0;
              .adapt_pc_widescreen & {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                
              }
            }
          }
          .hrname {
            color: #7c8087;
            margin-left: 4px;
            margin-right: 5px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            .adapt_pc_widescreen & {
              margin-right: 8px;
            }
          }
        }
        .hrtag {
          color: #afb3ba;
        }
      }
    }
  }
  .deliverysBtn {
    width: 184px;
    height: 36px;
    background: linear-gradient(180deg, #ffbd65 0%, #ff6332 100%);
    box-shadow: inset 0px 1px 0px 0px #ffd99c, inset 0px -1px 5px 0px #ffb843;
    border-radius: 18px;
    border: 1px solid rgb(255, 99, 50);
    // opacity: 0.7;
    // font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    font-style: normal;
    margin: 0 auto;
    margin-top: 8px;
    line-height: 34px;
    box-sizing: border-box;
    .adapt_pc_widescreen & {

    }
    .adapt_pc_widescreen & {
      width: 258px;
      height: 50px;
      border-radius: 26px;
      line-height: 50px;
      font-size: 22px;
      margin-top: 16px;
    }
  }
  .deliverysBtnGray {
    border: 0;
    border: 1px solid rgba(255, 99, 50, 0.8);
    opacity: 0.6;
  }

  .moreBtn {
    font-size: 13px;
    color: #4C4F54;
    text-align: center;
    cursor: pointer;
    &.moreBtnHide {
      display: none;
    }
    .text {
      display: inline-block;
      line-height: 30px;
      padding-right: 14px;
      background: url("@/assets/img/activity/arrow_down.png") right center no-repeat;
      background-size: 10px 10px;
    }
  }
}
  </style>
  